"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _contentType = require("@insided/shared/utils/contentType");

var _topicService = require("../services/topicService");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _inputUnit = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/input-unit"));

var _textField = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/text-field"));

var _logger = require("@insided/shared/services/logger");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getSuccessMessage(multipleReplies, topic) {
  var _topic$url;

  var topicUrl = "".concat(window.location.origin).concat((_topic$url = topic.url) === null || _topic$url === void 0 ? void 0 : _topic$url.split('.com')[1]);
  var topicLink = "<a href=\"".concat(topicUrl, "\">").concat(topic.title, "</a>");
  return "The ".concat(multipleReplies ? 'replies have' : 'reply has', " been successfully moved to ").concat(topicLink);
}

var SUPPORTED_DESTINATION_TYPES = [_contentType.CONTENT_TYPE_QUESTION, _contentType.CONTENT_TYPE_CONVERSATION, _contentType.CONTENT_TYPE_ARTICLE];

var MoveToExistingTopicModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(MoveToExistingTopicModal, _PureComponent);

  var _super = _createSuper(MoveToExistingTopicModal);

  function MoveToExistingTopicModal() {
    var _this;

    (0, _classCallCheck2.default)(this, MoveToExistingTopicModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      isUrlValid: false,
      topic: null,
      error: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isMovingTopic", function () {
      return !!_this.props.topicId;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isMovingMultipleReplies", function () {
      var _this$props = _this.props,
          replyId = _this$props.replyId,
          selectedReplies = _this$props.selectedReplies;
      return !replyId && !!selectedReplies && selectedReplies.length > 1;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getConfirmationMessage", function (topicTitle) {
      if (_this.isMovingTopic()) {
        return "You are about to move this topic as a reply to: ".concat(topicTitle, ". The original topic will no longer exist as a standalone topic. Are you sure you want to do this?");
      }

      var subject = _this.isMovingMultipleReplies() ? 'replies' : 'reply';
      return "You are about to move the selected ".concat(subject, " to the topic: ").concat(topicTitle, ". The position will be based on the date and time originally posted. Are you sure you want to do this?");
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDestinationError", function (destinationContentType, destinationTopicId) {
      var _this$props2 = _this.props,
          publicId = _this$props2.publicId,
          contentType = _this$props2.contentType,
          visibleReplyCount = _this$props2.visibleReplyCount;

      if (publicId && parseInt(publicId) === destinationTopicId) {
        return 'Unable to move this content. Please make sure the origin and destination are not the same.';
      }

      if (!SUPPORTED_DESTINATION_TYPES.includes(destinationContentType)) {
        var readableType = (0, _contentType.getReadableContentType)(destinationContentType);

        if (_this.isMovingTopic()) {
          return "Moving a topic to a ".concat(readableType, " is not supported. Topics can only be moved to a question, conversation, or article.");
        }

        return "Moving replies to a ".concat(readableType, " is not supported. Replies can only be moved to a question, conversation, or article.");
      }

      if (visibleReplyCount) {
        return "".concat(contentType, " with visible replies cannot be converted to a reply. Please first trash or move the replies and try again.");
      }

      return null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkUrl", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(topicUrl) {
        var topic, destinationContentType;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _topicService.getTopicByUrl)(topicUrl);

              case 3:
                topic = _context.sent;
                destinationContentType = (0, _contentType.getConsistentContentType)(topic.contenttype);

                _this.setState({
                  topic: {
                    id: topic.threadid,
                    title: topic.topictitle,
                    contentType: destinationContentType,
                    url: topic.url
                  },
                  isUrlValid: true,
                  error: _this.getDestinationError(destinationContentType, topic.threadid)
                });

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                _this.setState({
                  error: 'No topic found for this url, please try something else.',
                  isUrlValid: false,
                  topic: null
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMoveTopicToExistingTopic", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$props3, contentType, topicId, onShowAlert, topic, privateId;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props3 = _this.props, contentType = _this$props3.contentType, topicId = _this$props3.topicId, onShowAlert = _this$props3.onShowAlert;
              topic = _this.state.topic;

              if (!(!topicId || !topic)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              _this.setState({
                isLoading: true
              });

              _context2.prev = 5;
              _context2.next = 8;
              return (0, _topicService.getPrivateId)(Number(topic.id));

            case 8:
              privateId = _context2.sent;
              _context2.next = 11;
              return (0, _topicService.moveTopicToExistingTopic)(contentType, topicId, privateId, topic.contentType);

            case 11:
              window.location.assign("".concat(window.location.origin, "/topic/show?tid=").concat(topic.id));
              _context2.next = 18;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](5);

              _logger.logger.error(_context2.t0, {
                component: 'MoveToExistingTopicModal',
                action: 'moveTopicToExistingTopic'
              });

              onShowAlert('error');

            case 18:
              _this.setState({
                isLoading: false,
                isUrlValid: false
              });

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[5, 14]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMoveReplyToExistingTopic", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _this$props4, contentType, replyId, onShowAlert, onClose, selectedReplies, getReplies, setSelectedReplies, topic, replyIds, privateId;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props4 = _this.props, contentType = _this$props4.contentType, replyId = _this$props4.replyId, onShowAlert = _this$props4.onShowAlert, onClose = _this$props4.onClose, selectedReplies = _this$props4.selectedReplies, getReplies = _this$props4.getReplies, setSelectedReplies = _this$props4.setSelectedReplies;
              topic = _this.state.topic;
              replyIds = replyId ? [String(replyId)] : selectedReplies;

              if (!(!replyIds || !topic || typeof getReplies !== 'function')) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt("return");

            case 5:
              _this.setState({
                isLoading: true
              });

              _context4.prev = 6;
              _context4.next = 9;
              return (0, _topicService.getPrivateId)(Number(topic.id));

            case 9:
              privateId = _context4.sent;
              _context4.next = 12;
              return (0, _topicService.moveRepliesToExistingTopic)(contentType, replyIds, privateId, topic.contentType);

            case 12:
              onClose();
              onShowAlert('success', getSuccessMessage(replyIds.length > 1, topic));
              setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
                return _regenerator.default.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return getReplies();

                      case 2:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              })), 500);

              if (!replyId && typeof setSelectedReplies === 'function') {
                setSelectedReplies([]);
              }

              _context4.next = 22;
              break;

            case 18:
              _context4.prev = 18;
              _context4.t0 = _context4["catch"](6);

              _logger.logger.error(_context4.t0, {
                component: 'MoveToExistingTopicModal',
                action: 'moveReplyToExistingTopic'
              });

              onShowAlert('error');

            case 22:
              _this.setState({
                isLoading: false
              });

            case 23:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[6, 18]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(MoveToExistingTopicModal, [{
    key: "render",
    value: function render() {
      var _topic$title;

      var _this$props5 = this.props,
          onClose = _this$props5.onClose,
          moveType = _this$props5.moveType;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          error = _this$state.error,
          topic = _this$state.topic,
          isUrlValid = _this$state.isUrlValid;
      return (0, _preact.h)(_modal.default, {
        onClose: onClose,
        isControl: true
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: moveType
      }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)(_inputUnit.default, {
        label: "Enter the link of the topic you want to move the comment to:",
        isControl: true,
        error: error !== null && error !== void 0 ? error : undefined
      }, (0, _preact.h)(_textField.default, {
        id: "move-to-topic",
        ariaLabel: "move-to-topic",
        name: "move-to-topic",
        isControl: true,
        placeholder: "http://",
        onKeyUp: this.checkUrl,
        type: "text"
      })), topic && isUrlValid && (0, _preact.h)("div", {
        className: "valid-url-message"
      }, (0, _preact.h)(_inputUnit.default, {
        label: "Topic: ".concat(topic.title, " ")
      }, (0, _preact.h)("div", null, this.getConfirmationMessage((_topic$title = topic.title) !== null && _topic$title !== void 0 ? _topic$title : ''))))), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        title: moveType,
        variant: "primary",
        onClick: this.isMovingTopic() ? this.onMoveTopicToExistingTopic : this.onMoveReplyToExistingTopic,
        isLoading: isLoading,
        disabled: !isUrlValid || !!error,
        size: "medium",
        "data-qa": moveType
      })));
    }
  }]);
  return MoveToExistingTopicModal;
}(_preactCompat.PureComponent);

var _default = MoveToExistingTopicModal;
exports.default = _default;